/**
 * Module NEUTRE « news-display » — KEEP IN SYNC avec
 * inventozen-frontpublic/src/cms-puck/news-display.ts
 *
 * Résolution de la liste d'actualités affichée par le bloc `News` :
 * mode auto (récentes du tenant) ou manuel (ids choisis).
 */

export type NewsDisplayMode = "auto" | "manual";

export type NewsBlockProps = {
  mode?: unknown;
  newsIds?: unknown;
  limit?: unknown;
  featured?: unknown;
};

export function normalizeNewsMode(value: unknown): NewsDisplayMode {
  return value === "manual" ? "manual" : "auto";
}

export function normalizeNewsIds(value: unknown): string[] {
  if (!Array.isArray(value)) return [];
  const out: string[] = [];
  const seen = new Set<string>();
  for (const raw of value) {
    const id = String(raw ?? "").trim();
    if (!id || seen.has(id)) continue;
    seen.add(id);
    out.push(id);
  }
  return out;
}

export function normalizeNewsLimit(value: unknown): number | undefined {
  const n = Number(value);
  if (!Number.isFinite(n) || n <= 0) return undefined;
  return Math.min(50, Math.floor(n));
}

/** Filtre et ordonne les actualités selon les props structurelles du bloc. */
export function resolveNewsForBlock<T extends { id: string }>(
  allNews: T[],
  props: NewsBlockProps,
): T[] {
  const mode = normalizeNewsMode(props.mode);
  const ids = normalizeNewsIds(props.newsIds);
  const max = normalizeNewsLimit(props.limit);

  let list: T[];
  if (mode === "manual" && ids.length > 0) {
    const byId = new Map(allNews.map((n) => [n.id, n]));
    list = ids.map((id) => byId.get(id)).filter((n): n is T => !!n);
  } else {
    list = [...allNews];
  }

  return max ? list.slice(0, max) : list;
}
